class ProductUpsells extends HTMLElement {
    constructor() {
        super()

        this._selectors = {
            checkbox: 'input.upsell-item-checkbox',
            bundle: '[js-upsell-bundle]',
            bundleLabel: '[js-upsell-bundle-title]',
            upsellRow: '[js-upsell-row]',
            selectBtn: '[js-select-upsell]'
        }

        this.checkboxes = this.querySelectorAll(this._selectors.checkbox)

        this.bundles = this.querySelectorAll(this._selectors.bundle)

        this.upsellRows = this.querySelectorAll(this._selectors.upsellRow)

        this.discountConfig = {
            pickFreeMax: this.getAttribute('data-bundle-pick-max'),
            tieredMin: this.getAttribute('data-bundle-discount-min'),
            tieredDiscount: this.getAttribute('data-bundle-discount-amount'),
        }

        this.events = {
            change: 'upsell:change'
        }
    }

    connectedCallback() {
        this.upsellRows.forEach((row) => {
            const checkbox = row.querySelector(this._selectors.checkbox)
            const button = row.querySelector(this._selectors.selectBtn)

            if(!checkbox || !button) return

            if(checkbox.checked) this._handleClick(row, button, checkbox)

            button.addEventListener('click', (evt) => {
                this._handleClick(row, button, checkbox, true)
            })
        })
    }

    _handleClick(row, button, checkbox, isClicked = false) {
        if(isClicked){
            if (button.getAttribute('disabled')) return
            button.setAttribute('aria-selected', !checkbox.checked)
            checkbox.checked = !checkbox.checked
        }

        const bundleContainer = row.closest('[js-upsell-bundle]')

        if (bundleContainer) {
            const bundleType = bundleContainer.getAttribute('js-upsell-bundle-type')
            if (bundleType === 'pick free') this._handlePickFreeBundle(bundleContainer)
            else if (bundleType === 'tiered discount') this._handleTieredDiscount(bundleContainer)
        }

        document.dispatchEvent(
            new CustomEvent(this.events.change)
        )
    }

    /* Pick X Free Accessories */
    _handlePickFreeBundle(wrapperElm) {
        const tabTitle = this._getGroupLabel(wrapperElm)
        const selectedAmount = wrapperElm.querySelectorAll('input:checked')
        const shouldApplyDiscount = selectedAmount.length >= this.discountConfig.pickFreeMax

        let totalSavings = 0
        let savingsIndex = 0

        wrapperElm.querySelectorAll(this._selectors.upsellRow).forEach((item) => {

            const comparePriceText = item.querySelector('span.old-price')

            const priceText = item.querySelector('span.new-price')
            const price = Number(priceText.getAttribute('data-price'))
            const checkbox = item.querySelector('input')

            let isItemChecked = checkbox.checked ? true : false

            if (isItemChecked) savingsIndex++

            if (isItemChecked && savingsIndex <= this.discountConfig.pickFreeMax) {
                totalSavings += price

                priceText.innerHTML = 'FREE'

                if (comparePriceText.classList.contains('hidden')) {
                    comparePriceText.innerHTML = formatMoney(price, '${{no_trailing_zeros}}')
                    comparePriceText.classList.remove('hidden')
                }

                checkbox.setAttribute('data-product-price', 0)
                checkbox.setAttribute('data-product-savings', price)

            }

            if (!isItemChecked || savingsIndex > this.discountConfig.pickFreeMax) {
                checkbox.removeAttribute('data-savings')
                comparePriceText.classList.add('hidden')
                priceText.innerHTML = price === 0 ? 'FREE' : formatMoney(price, '${{no_trailing_zeros}}')
            }
        })

        if (selectedAmount.length === this.discountConfig.pickFreeMax) {
            wrapperElm.querySelectorAll(this._selectors.upsellRow).forEach((item) => {
                const checkbox = item.querySelector('input')
                const button = item.querySelector(this._selectors.selectBtn)
                if (!checkbox.checked) button.setAttribute('disabled', true)
            })
        } else {
            wrapperElm.querySelectorAll(this._selectors.upsellRow).forEach((item) => {
                const checkbox = item.querySelector('input')
                const button = item.querySelector(this._selectors.selectBtn)
                button.removeAttribute('disabled')
            })
        }


        let labelConfig = { isComplete: false }

        if (selectedAmount.length >= this.discountConfig.pickFreeMax) {
            labelConfig = { isComplete: true, remaining: 0, amount: totalSavings }
        } else if (selectedAmount.length > 0) {
            labelConfig = { isComplete: false, remaining: this.discountConfig.pickFreeMax - selectedAmount.length }
        } else {
            labelConfig = { isComplete: false, remaining: this.discountConfig.pickFreeMax }
        }

        if (tabTitle) this._setPickFreeBundleLabel(tabTitle, labelConfig)
        wrapperElm.setAttribute('data-discount-applied', shouldApplyDiscount ? 'true' : 'false')

        document.dispatchEvent(
            new CustomEvent(this.events.change)
        )
    }

    _setPickFreeBundleLabel(label, {
        isComplete = false, remaining = this.discountConfig.pickFreeMax, amount
    }) {
        if (!label) return

        if (isComplete) {
            label.innerHTML = `Order Now & Save ${formatMoney(amount, '${{no_trailing_zeros}}')}`
        } else if (remaining === this.discountConfig.pickFreeMax) {
            label.innerHTML = `Pick ${this.discountConfig.pickFreeMax} Free Accessories`
        } else if (remaining === 1) {
            label.innerHTML = `Pick ${remaining} More Free Accessory`
        } else if (remaining !== this.discountConfig.pickFreeMax) {
            label.innerHTML = `Pick ${remaining} More Free Accessories`
        }
    }

    /* Buy X Get X% Off */
    _handleTieredDiscount(wrapperElm) {
        const tabTitle = this._getGroupLabel(wrapperElm)

        const selectedAmount = wrapperElm.querySelectorAll('input:checked')
        const shouldApplyDiscount = selectedAmount.length >= this.discountConfig.tieredMin

        let totalSavings = 0
        let savingsIndex = 0

        wrapperElm.querySelectorAll(this._selectors.upsellRow).forEach((item) => {
            const comparePriceText = item.querySelector('span.old-price')
            const priceText = item.querySelector('span.new-price')

            const price = Number(priceText.getAttribute('data-price'))

            const checkbox = item.querySelector('input')
            const isItemChecked = checkbox.checked ? true : false

            if (isItemChecked) savingsIndex++

            if (isItemChecked && selectedAmount.length >= this.discountConfig.tieredMin) {
                totalSavings += price * (this.discountConfig.tieredDiscount / 100)
                priceText.innerHTML = formatMoney(price - (price * (this.discountConfig.tieredDiscount / 100)), '${{no_trailing_zeros}}')

                if (comparePriceText.classList.contains('hidden')) {
                    comparePriceText.innerHTML = formatMoney(price, '${{no_trailing_zeros}}')
                    comparePriceText.classList.remove('hidden')
                }

                checkbox.setAttribute('data-product-savings', price)
                checkbox.setAttribute('data-product-price', price * (this.discountConfig.tieredDiscount / 100))
            }

            if (!isItemChecked || selectedAmount.length < this.discountConfig.tieredMin) {
                checkbox.removeAttribute('data-discount')

                checkbox.setAttribute('data-product-savings', 0)
                checkbox.setAttribute('data-product-price', price)


                const compareDefaultPrice = Number(comparePriceText.getAttribute('data-price')) ?? false
                if (compareDefaultPrice) {
                    comparePriceText.classList.remove('hidden')
                    comparePriceText.innerHTML = formatMoney(compareDefaultPrice, '${{no_trailing_zeros}}')
                } else {
                    comparePriceText.classList.add('hidden')
                }

                priceText.innerHTML = price === 0 ? 'FREE' : formatMoney(price, '${{no_trailing_zeros}}')
            }

        })

        let labelConfig = { isComplete: false }

        if (selectedAmount.length >= this.discountConfig.tieredMin) {
            labelConfig = { isComplete: true, remaining: 0, amount: totalSavings }
        } else if (selectedAmount.length > 0) {
            labelConfig = { isComplete: false, remaining: this.discountConfig.tieredMin - selectedAmount.length }
        } else {
            labelConfig = { isComplete: false, remaining: this.discountConfig.tieredMin }
        }

        if (tabTitle) this.setTieredLabel(tabTitle, labelConfig)
        wrapperElm.setAttribute('data-discount-applied', shouldApplyDiscount ? 'true' : 'false')

        document.dispatchEvent(
            new CustomEvent(this.events.change)
        )
    }

    setTieredLabel(label, {
        isComplete = false, remaining = this.discountConfig.tieredMin, amount
    }) {
        if (!label) return

        if (isComplete) {
            label.innerHTML = `Order Now & Save ${formatMoney(amount, '${{no_trailing_zeros}}')}`
        } else if (remaining === this.discountConfig.tieredMax) {
            label.innerHTML = `Add ${this.discountConfig.tieredMax}, Save ${this.discountConfig.tieredDiscount}%`
        } else if (remaining !== this.discountConfig.minSelect) {
            label.innerHTML = `Add ${remaining} more, Save ${this.discountConfig.tieredDiscount}%`
        }
    }

    /* Utils */
    _getGroupLabel(wrapperElm) {
        const groupWrapper = wrapperElm.closest('.upsell-wrapper')
        const isAccordion = wrapperElm.classList.contains('upsell-group--accordion') ?? false
        const isTab = wrapperElm.getAttribute('role') === "tabpanel"
        let tabTitle

        if (isTab) {
            const tabTitleId = wrapperElm.getAttribute('aria-labelledby')
            tabTitle = this.querySelector(`#${tabTitleId}`)
        } else if (isAccordion) {
            tabTitle = wrapperElm.querySelector(this._selectors.bundleLabel)
        } else {
            tabTitle = groupWrapper.querySelector(this._selectors.bundleLabel)
        }

        return tabTitle
    }

}

if (!customElements.get('product-upsells')) {
    customElements.define("product-upsells", ProductUpsells)
}